import React, { useState, useEffect } from "react";

import { NavLink, useLocation } from "react-router-dom";
import Button from "../components/UI/Button";
import useMediaQuery from "../hooks/useMediaQuery";

import classes from "../sass/Layout/MainHeader.module.scss";

const optionList = ["home", "stories", "features", "pricing"];

const MainHeader = () => {
	const [isBurgerOpen, setIsBurgerOpen] = useState(false);
	const [menuList, setMenuList] = useState(optionList);
	const location = useLocation();
	const screenTablet = useMediaQuery("(min-width: 768px)");

	const { pathname } = location;

	useEffect(() => {
		setMenuList(optionList.filter((el) => el !== pathname.replace("/", "")));
	}, [pathname]);

	const burgerOpenHandler = () => {
		setIsBurgerOpen((prevState) => !prevState);
	};

	return (
		<header className={classes["main-header"]}>
			<nav className={classes["nav"]}>
				<svg
					width="170"
					height="16"
					viewBox="0 0 170 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M70.1027 15.3622C69.0721 15.7874 67.9658 16 66.7838 16C65.5874 16 64.4775 15.7874 63.4541 15.3622C62.4306 14.9369 61.5405 14.3568 60.7838 13.6216C60.027 12.8865 59.4324 12.036 59 11.0703C58.5676 10.1045 58.3514 9.08108 58.3514 8C58.3514 6.91892 58.5676 5.8955 59 4.92973C59.4324 3.96396 60.027 3.11351 60.7838 2.37838C61.5405 1.64324 62.4306 1.06306 63.4541 0.637838C64.4775 0.212613 65.5874 0 66.7838 0C67.9658 0 69.0721 0.212613 70.1027 0.637838C71.1333 1.06306 72.027 1.64324 72.7838 2.37838C73.5405 3.11351 74.1351 3.96396 74.5676 4.92973C75 5.8955 75.2162 6.91892 75.2162 8C75.2162 9.08108 75 10.1045 74.5676 11.0703C74.1351 12.036 73.5405 12.8865 72.7838 13.6216C72.027 14.3568 71.1333 14.9369 70.1027 15.3622ZM31.1081 11.027V15.5676H27V0.432432H33.8108C34.6468 0.432432 35.4108 0.565766 36.1027 0.832432C36.7946 1.0991 37.3856 1.47027 37.8757 1.94595C38.3658 2.42162 38.7477 2.98378 39.0216 3.63243C39.2955 4.28108 39.4324 4.98018 39.4324 5.72973C39.4324 6.49369 39.2955 7.1964 39.0216 7.83784C38.7477 8.47928 38.3658 9.03784 37.8757 9.51351C37.3856 9.98919 36.7946 10.3604 36.1027 10.627C35.4108 10.8937 34.6468 11.027 33.8108 11.027H31.1081ZM31.1081 7.35135H33.5946C34.0847 7.35135 34.4955 7.18919 34.827 6.86486C35.1586 6.54054 35.3243 6.16216 35.3243 5.72973C35.3243 5.2973 35.1586 4.91892 34.827 4.59459C34.4955 4.27027 34.0847 4.10811 33.5946 4.10811H31.1081V7.35135ZM46.1351 15.5676V9.72973H51.6486V15.5676H55.7568V0.432432H51.6486V6.05405H46.1351V0.432432H42.027V15.5676H46.1351ZM66.7838 12.3243C66.1928 12.3243 65.6378 12.2162 65.1189 12C64.6 11.7838 64.1532 11.4811 63.7784 11.0919C63.4036 10.7027 63.1081 10.245 62.8919 9.71892C62.6757 9.19279 62.5676 8.61982 62.5676 8C62.5676 7.38018 62.6757 6.80721 62.8919 6.28108C63.1081 5.75495 63.4036 5.2973 63.7784 4.90811C64.1532 4.51892 64.6 4.21622 65.1189 4C65.6378 3.78378 66.1928 3.67568 66.7838 3.67568C67.3748 3.67568 67.9261 3.78378 68.4378 4C68.9495 4.21622 69.3964 4.51892 69.7784 4.90811C70.1604 5.2973 70.4595 5.75495 70.6757 6.28108C70.8919 6.80721 71 7.38018 71 8C71 8.61982 70.8919 9.19279 70.6757 9.71892C70.4595 10.245 70.1604 10.7027 69.7784 11.0919C69.3964 11.4811 68.9495 11.7838 68.4378 12C67.9261 12.2162 67.3748 12.3243 66.7838 12.3243ZM84.8378 4.10811V15.5676H80.7297V4.10811H76.5135V0.432432H89.0541V4.10811H84.8378ZM98.7838 16C99.9658 16 101.072 15.7874 102.103 15.3622C103.133 14.9369 104.027 14.3568 104.784 13.6216C105.541 12.8865 106.135 12.036 106.568 11.0703C107 10.1045 107.216 9.08108 107.216 8C107.216 6.91892 107 5.8955 106.568 4.92973C106.135 3.96396 105.541 3.11351 104.784 2.37838C104.027 1.64324 103.133 1.06306 102.103 0.637838C101.072 0.212613 99.9658 0 98.7838 0C97.5874 0 96.4775 0.212613 95.4541 0.637838C94.4306 1.06306 93.5405 1.64324 92.7838 2.37838C92.027 3.11351 91.4324 3.96396 91 4.92973C90.5676 5.8955 90.3514 6.91892 90.3514 8C90.3514 9.08108 90.5676 10.1045 91 11.0703C91.4324 12.036 92.027 12.8865 92.7838 13.6216C93.5405 14.3568 94.4306 14.9369 95.4541 15.3622C96.4775 15.7874 97.5874 16 98.7838 16ZM97.1189 12C97.6378 12.2162 98.1928 12.3243 98.7838 12.3243C99.3748 12.3243 99.9261 12.2162 100.438 12C100.95 11.7838 101.396 11.4811 101.778 11.0919C102.16 10.7027 102.459 10.245 102.676 9.71892C102.892 9.19279 103 8.61982 103 8C103 7.38018 102.892 6.80721 102.676 6.28108C102.459 5.75495 102.16 5.2973 101.778 4.90811C101.396 4.51892 100.95 4.21622 100.438 4C99.9261 3.78378 99.3748 3.67568 98.7838 3.67568C98.1928 3.67568 97.6378 3.78378 97.1189 4C96.6 4.21622 96.1532 4.51892 95.7784 4.90811C95.4036 5.2973 95.1081 5.75495 94.8919 6.28108C94.6757 6.80721 94.5676 7.38018 94.5676 8C94.5676 8.61982 94.6757 9.19279 94.8919 9.71892C95.1081 10.245 95.4036 10.7027 95.7784 11.0919C96.1532 11.4811 96.6 11.7838 97.1189 12ZM114.568 16C115.519 16 116.369 15.8667 117.119 15.6C117.868 15.3333 118.503 14.973 119.022 14.5189C119.541 14.0649 119.937 13.5387 120.211 12.9405C120.485 12.3423 120.622 11.7045 120.622 11.027C120.622 10.1477 120.449 9.42703 120.103 8.86487C119.757 8.3027 119.324 7.84865 118.805 7.5027C118.286 7.15676 117.721 6.88288 117.108 6.68108C116.495 6.47928 115.93 6.29189 115.411 6.11892C114.892 5.94595 114.459 5.76216 114.114 5.56757C113.768 5.37297 113.595 5.1027 113.595 4.75676C113.595 4.42523 113.742 4.12613 114.038 3.85946C114.333 3.59279 114.726 3.45946 115.216 3.45946C115.591 3.45946 115.93 3.52072 116.232 3.64324C116.535 3.76577 116.795 3.90631 117.011 4.06486C117.27 4.23784 117.501 4.43243 117.703 4.64865L120.081 2.16216C119.735 1.75856 119.31 1.3982 118.805 1.08108C118.373 0.807207 117.825 0.558559 117.162 0.335135C116.499 0.111712 115.706 0 114.784 0C113.919 0 113.133 0.12973 112.427 0.389189C111.721 0.648649 111.119 0.994595 110.622 1.42703C110.124 1.85946 109.739 2.35676 109.465 2.91892C109.191 3.48108 109.054 4.05766 109.054 4.64865C109.054 5.52793 109.227 6.24865 109.573 6.81081C109.919 7.37297 110.351 7.82703 110.87 8.17297C111.389 8.51892 111.955 8.79279 112.568 8.99459C113.18 9.1964 113.746 9.38378 114.265 9.55676C114.784 9.72973 115.216 9.91351 115.562 10.1081C115.908 10.3027 116.081 10.573 116.081 10.9189C116.081 11.3514 115.908 11.7297 115.562 12.0541C115.216 12.3784 114.741 12.5405 114.135 12.5405C113.645 12.5405 113.202 12.4577 112.805 12.2919C112.409 12.1261 112.067 11.9423 111.778 11.7405C111.447 11.4955 111.151 11.2216 110.892 10.9189L108.514 13.4054C108.946 13.8955 109.458 14.3279 110.049 14.7027C110.553 15.0342 111.18 15.3333 111.93 15.6C112.679 15.8667 113.559 16 114.568 16ZM127.108 7.13514V15.5676H123V0.432432H126.568L133.054 8.86486V0.432432H137.162V15.5676H133.616L127.108 7.13514ZM143.324 15.5676L144.405 12.3243H149.378L150.459 15.5676H154.892L149.162 0.432432H144.622L138.892 15.5676H143.324ZM146.892 4.64865L145.486 9.08108H148.297L146.892 4.64865ZM160.73 15.5676V11.027H163.432C164.268 11.027 165.032 10.8937 165.724 10.627C166.416 10.3604 167.007 9.98919 167.497 9.51351C167.987 9.03784 168.369 8.47928 168.643 7.83784C168.917 7.1964 169.054 6.49369 169.054 5.72973C169.054 4.98018 168.917 4.28108 168.643 3.63243C168.369 2.98378 167.987 2.42162 167.497 1.94595C167.007 1.47027 166.416 1.0991 165.724 0.832432C165.032 0.565766 164.268 0.432432 163.432 0.432432H156.622V15.5676H160.73ZM160.73 7.35135H163.216C163.706 7.35135 164.117 7.18919 164.449 6.86486C164.78 6.54054 164.946 6.16216 164.946 5.72973C164.946 5.2973 164.78 4.91892 164.449 4.59459C164.117 4.27027 163.706 4.10811 163.216 4.10811H160.73V7.35135Z"
						fill="black"
					/>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M0 16L9.5 0L19 16H0Z"
						fill="url(#paint0_linear_0_799)"
					/>
					<defs>
						<linearGradient
							id="paint0_linear_0_799"
							x1="9.5"
							y1="20"
							x2="16.6529"
							y2="3.01176"
							gradientUnits="userSpaceOnUse"
						>
							<stop stop-color="#FFC593" />
							<stop offset="0.519452" stop-color="#BC7198" />
							<stop offset="1" stop-color="#5A77FF" />
						</linearGradient>
					</defs>
				</svg>

				{!screenTablet && (
					<div
						className={`${classes["nav__menu-btn"]} ${
							isBurgerOpen && classes.open
						}`}
						onClick={burgerOpenHandler}
					>
						<div className={classes["nav__menu-btn--burger_top"]}></div>
						<div className={classes["nav__menu-btn--burger_bottom"]}></div>
					</div>
				)}

				{screenTablet && (
					<>
						<div className={classes["main-header__menu-options"]}>
							<div className={classes["main-header__menu-options__link-group"]}>
								{menuList.map((el) => (
									<NavLink
										key={`${Math.random()}`}
										to={`/${el}`}
										className={classes["main-header__menu-options__link"]}
										onClick={burgerOpenHandler}
									>
										{el.toUpperCase()}
									</NavLink>
								))}
							</div>
						</div>

						<Button className={classes["main-header__menu-options__button"]}>
							GET AN INVITE
						</Button>
					</>
				)}
			</nav>

			{!screenTablet && (
				<div
					className={`${classes["main-header__menu-options"]} ${
						isBurgerOpen && classes["menu-options"]
					}`}
				>
					{menuList.map((el) => (
						<NavLink
							key={`${Math.random()}`}
							to={`/${el}`}
							className={classes["main-header__menu-options__link"]}
							onClick={burgerOpenHandler}
						>
							{el.toUpperCase()}
						</NavLink>
					))}

					<div className={classes["main-header__menu-options__line"]}></div>

					<Button className={classes["main-header__menu-options__button"]}>
						GET AN INVITE
					</Button>
				</div>
			)}
		</header>
	);
};

export default MainHeader;
